import { render, staticRenderFns } from "./konva-preview-modal.vue?vue&type=template&id=228e3ae6&scoped=true"
import script from "./konva-preview-modal.vue?vue&type=script&lang=js"
export * from "./konva-preview-modal.vue?vue&type=script&lang=js"
import style0 from "./konva-preview-modal.vue?vue&type=style&index=0&id=228e3ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e3ae6",
  null
  
)

export default component.exports